@if (_context) {
    <mat-tab-group class="detail-tabs">
        <mat-tab label="Infos">
            <app-channel-form
                [disabled]="_context.formMode === FormMode.Reading"
                [context]="_context.formContext"
                [channel]="_context.formContext.item"
                (channelUpdated)="onChannelUpdated($event)"
                (canceled)="onCanceled($event)"></app-channel-form>
        </mat-tab>
        @if (!!_context.formContext.item.id) {
            <mat-tab label="Identification des clients">
                <app-customer-identification
                    className="channel-tab-gridview"
                    [context]="_context.formContext"
                    (customerUpdated)="onCustomerIdentificationsUpdated($event)"
                    (canceled)="onCanceled($event)"></app-customer-identification>
            </mat-tab>
            <mat-tab label="Identification des types de documents">
                <app-document-type-identification
                    className="channel-tab-gridview"
                    [context]="_context.formContext"
                    (documentTypeUpdated)="onDocumentTypeIdentificationsUpdated($event)"
                    (canceled)="onCanceled($event)"></app-document-type-identification>
            </mat-tab>
            <mat-tab label="Assignation d'attributs">
                <app-attributes-assignment
                    className="channel-tab-gridview"
                    [context]="_context.formContext"
                    (attributesAssignmentUpdated)="onAttributeAssignmentsUpdated($event)"
                    (canceled)="onCanceled($event)"></app-attributes-assignment>
            </mat-tab>
            <mat-tab label="Rattachement automatique">
                <app-auto-link
                    className="channel-tab-gridview"
                    [context]="_context.formContext"
                    (autoLinkUpdated)="onAutoLinksUpdated($event)"
                    (canceled)="onCanceled($event)"></app-auto-link>
            </mat-tab>
        }
    </mat-tab-group>
}
